// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { primaryToolbarPlugin } from '@atlaskit/editor-plugin-primary-toolbar';
export type {
	PrimaryToolbarPlugin,
	PrimaryToolbarPluginState,
	ToolbarElementNames,
} from '@atlaskit/editor-plugin-primary-toolbar';
